import { getCurrencyByCountryCode } from '~/features/internationalization/utils/get-currency-by-country-code';

/**
 * Resolves the currency used for promotion restriction checks.
 * Prefer `viewer_currency` when present; otherwise map `viewer_country`, then USD.
 */
export function resolvePromotionCurrency({
  viewerCurrencyCookie,
  viewerCountry,
}: {
  viewerCurrencyCookie?: string;
  viewerCountry?: string;
}): string {
  if (viewerCurrencyCookie) {
    return viewerCurrencyCookie;
  }

  return getCurrencyByCountryCode(viewerCountry) ?? 'USD';
}
